export default {
    CONTATO_NF_RECEBE: {
        id: "CONTATO_NF_RECEBE",
        nome: "Recebe Nota Fiscal",
    },
}